module.exports = __webpack_public_path__ + "static/media/Mapa.70527c02.png";